import Tabs from './tabs';
import TabPane from './tab-pane';

Tabs.TabPane = TabPane;
export default Tabs;
